import { StringType } from '../types';

/**
 *
 * @param string ie: I am a string
 * @returns lowercase string with no spaces ie: iamastring
 */
export const makeId = (string?: StringType) =>
    string?.toString().replace(/ /g, '').toLowerCase() ?? '';
